import track from './track';
import getProductData, { prepareProductsData } from './get-product-data';

/**
 * @param {ISaleEvent} data
 * @return {*|*}
 */
export default function sale(data) {
    let products = prepareProductsData(data.products);

    return track({
        event: 'sale',
        reqDelivery: data.deliveryTime, //- Bezeichnet das Lieferfenster (zB.: von 19.02.2018 14:32 bis 19.02.2018 17:00)
        shippingMethod: 'amigos', //- Art der Versand (amigos)
        paymentMethod: 'kreditkarte', //- Art der Bezahlung (kreditkarte | twint)
        currency: 'CHF', // - Standard CHF
        estCartValue: data.value, // Geschätzte Warenkorbwert
        ecommerce: {
            purchase: {
                actionField: {
                    id: data.id, // - Standard
                    revenue: data.value, // - Bruttoumsatz - Geschätzter Warenkorbwert
                    shipping: data.shippingPrice, // Der Wert des Logistikservice / Picker Kosten
                },
                products: products.map(getProductData),
            },
        },
    });
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/sale.js